import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import type { LabelAndValue } from '@/types/label-and-value'
import { requiredString } from '@/utils/zod'

type APIResponse = z.infer<typeof responseSchema>

const responseSchema = z.array(
  z.object({
    id: requiredString(),
    display_name: requiredString()
  })
)

const parseResponse = (results: APIResponse): LabelAndValue[] =>
  results.map(item => ({ value: item.id, label: item.display_name }))

type Params = {
  educationLevelId?: string
}

export const useAllCoursesOptions = (params: Params) =>
  useQuery({
    queryKey: ['panelCoursesListAll', params],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await httpService.panel.panelCoursesList({
        page: 1,
        page_size: 'max',
        education_level_id: params.educationLevelId
          ? [params.educationLevelId]
          : undefined,
        fetchKeys: {
          id: true,
          display_name: true
        }
      })

      return parseResponse(responseSchema.parse(response.results))
    }
  })
